"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getMenuItemId;
function getMenuItemId(position) {
  return "rbt-menu-item-" + position;
}


// WEBPACK FOOTER //
// ../node_modules/react-bootstrap-typeahead/lib/utils/getMenuItemId.js